import './InstagramFeed.css';

/* ─────────────────────────────────────────────────────
   Posts do Instagram
   Troque url, image e alt de cada post aqui:
───────────────────────────────────────────────────── */
const posts = [
  {
    url: "https://www.instagram.com/p/DL5KDUOuGZr/",
    image: "/images/instagram/post1.jpg",
    alt: "Look completo D.U"
  },
  {
    url: "https://www.instagram.com/p/DEqTtvlSe2z/",
    image: "/images/instagram/post3.jpg",
    alt: "Detalhes de costura"
  },
  {
    url: "https://www.instagram.com/p/C9lD8JCS77e/",
    image: "/images/instagram/post4.jpg",
    alt: "Novo lançamento"
  },
  {
    url: "https://www.instagram.com/p/DLh8fOQOtof/",
    image: "/images/instagram/post2.jpg",
    alt: "Coleção outono"
  }
];

/* ─────────────────────────────────────────────────────
   InstagramFeed
   Renderiza 4 posts diretamente (sem wrapper) para que
   o grid 2×2 da HomePage os posicione corretamente.
   display:contents no .instagram-grid-container faz isso.
───────────────────────────────────────────────────── */
const InstagramFeed = () => (
  <div className="instagram-grid-container">
    {posts.map((post, index) => (
      <InstagramPost key={index} post={post} />
    ))}
  </div>
);

/* Post individual */
const InstagramPost = ({ post }) => (
  <a
    href={post.url}
    target="_blank"
    rel="noopener noreferrer"
    className="instagram-grid-post"
    aria-label={`Post: ${post.alt}`}
  >
    <img
      src={process.env.PUBLIC_URL + post.image}
      alt={post.alt}
      className="post-image"
    />
    <div className="post-overlay">
      {/* Texto do hover — troque aqui */}
      <span className="hover-message">Ver no Instagram</span>
    </div>
  </a>
);

export default InstagramFeed;